"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    desc: "<p>\n    \u0431\u0443\u0434\u0435\u043C \u043C\u0435\u043D\u044F\u0442\u044C \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439 \u0442\u0435\u043A\u0441\u0442? \u041A\u043E\u043D\u0435\u0447\u043D\u043E \u0431\u0443\u0434\u0435\u043C!\n  </p>",
};
